import * as React from 'react'
import { useInView, useAnimation } from 'framer-motion'

export const useLeftRightAnimation = (ref: React.RefObject<Element | null>) => {
  const isInView = useInView(ref, { once: true })

  const controlsLeft = useAnimation()
  const controlsRight = useAnimation()

  const variants = {
    moveFromLeft: { x: ['-18%', '0%'], opacity: [0, 1], transition: { duration: 0.8, delay: 0.3 } },
    moveFromRight: { x: ['18%', '0%'], opacity: [0, 1], transition: { duration: 0.8 } },
  }

  React.useEffect(() => {
    if (isInView) {
      controlsRight.start('moveFromRight')
      controlsLeft.start('moveFromLeft')
    }
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInView])

  return { controlsLeft, controlsRight, variants }
}
